/* ────────────────────────────────────────
     BUILD YOUR OWN SET — isolated section-scoped controller
  ──────────────────────────────────────── */
  (function () {
    var registry = window.ESSNTLCustomSet || { instances: {}, lifecycleBound: false };

    function normaliseSearchText(value) {
      var text = String(value || '').toLowerCase();
      if (text.normalize) text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      return text.replace(/[^a-z0-9]+/g, ' ').trim();
    }

    function optionNameIndex(product, type) {
      var names = product && Array.isArray(product.option_names) ? product.option_names : [];
      var pattern = type === 'size' ? /(^|\s)sizes?(?=\s|$)/ : /(^|\s)colou?rs?(?=\s|$)/;

      for (var i = 0; i < names.length; i += 1) {
        if (pattern.test(normaliseSearchText(names[i]))) return i;
      }

      return -1;
    }

    function rawOptionAt(variant, index) {
      if (!variant || index < 0 || !Array.isArray(variant.options)) return '';
      return variant.options[index] == null ? '' : String(variant.options[index]);
    }

    function uniqueOptionValues(product, index) {
      var values = [];
      var seen = {};
      if (!product || index < 0 || !Array.isArray(product.variants)) return values;

      product.variants.forEach(function (variant) {
        var value = rawOptionAt(variant, index).trim();
        var key = value.toLowerCase();
        if (!value || seen[key]) return;
        seen[key] = true;
        values.push(value);
      });

      return values;
    }

    function prepareProductData(product, sourceIndex) {
      if (!product) return product;

      var detectedSizeIndex = optionNameIndex(product, 'size');
      var detectedColorIndex = optionNameIndex(product, 'color');
      var suppliedSizeIndex = parseInt(product.size_index, 10);
      var suppliedColorIndex = parseInt(product.color_index, 10);

      product.size_index = detectedSizeIndex >= 0
        ? detectedSizeIndex
        : (isFinite(suppliedSizeIndex) ? suppliedSizeIndex : -1);
      product.color_index = detectedColorIndex >= 0
        ? detectedColorIndex
        : (isFinite(suppliedColorIndex) ? suppliedColorIndex : -1);
      product._option_colors = uniqueOptionValues(product, product.color_index);

      // A single Color/Colour value means the colour is already represented by
      // this product card. Only multi-colour products need variant filtering.
      product.variant_color_index = product._option_colors.length > 1 ? product.color_index : -1;
      var suppliedSourceIndex = parseInt(product.source_order, 10);
      product._source_index = isFinite(suppliedSourceIndex) ? suppliedSourceIndex : sourceIndex;
      return product;
    }

    function extractColorFromTitle(title) {
      var match = String(title || '').match(/\s+in\s+(.+)$/i);
      return match && match[1] ? match[1].trim() : '';
    }

    function displayColor(product, selectedColor) {
      if (!product) return selectedColor || '';
      if (product.variant_color_index >= 0 && selectedColor) return selectedColor;
      if (product._option_colors && product._option_colors.length === 1) return product._option_colors[0];

      var titleColor = extractColorFromTitle(product.title);
      if (titleColor) return titleColor;
      if (selectedColor && normaliseSearchText(selectedColor) !== normaliseSearchText(product.title)) return selectedColor;
      return product.color || selectedColor || product.title || '';
    }

    function priorityFromSignal(signal) {
      /* Signature colourways first so a Midnight top lines up next to a Midnight
         bottom in the builder. Mixing stays allowed, exactly as before. */
      if (/(^|\s)(midnight)(?=\s|$)/.test(signal)) return -2;
      if (/(^|\s)(moonlight)(?=\s|$)/.test(signal)) return -1;
      if (/(^|\s)(grey|gray|cloud|ash|stone|silver|slate|graphite)(?=\s|$)/.test(signal)) return 0;
      if (/(^|\s)(black|night|onyx|noir|jet)(?=\s|$)/.test(signal)) return 1;
      if (/(^|\s)(blue|navy|sea|cobalt|azure|sky|indigo)(?=\s|$)/.test(signal)) return 2;
      if (/(^|\s)(pink|blossom|rose|blush|mauve)(?=\s|$)/.test(signal)) return 3;
      return 4;
    }

    function colorPriority(product, color) {
      var directPriority = priorityFromSignal(normaliseSearchText(color));
      if (directPriority < 4) return directPriority;

      return priorityFromSignal(normaliseSearchText([
        product && product.color,
        product && product.title,
        product && product.handle
      ].join(' ')));
    }

    function initRoot(root) {
      if (!root || root.getAttribute('data-ecs-init') === 'true') return;

      var sectionId = root.getAttribute('data-section-id') || '';
      var sectionScope = root.closest('#shopify-section-' + sectionId) || root.closest('.shopify-section') || document;
      var mount = sectionScope.querySelector('[data-ecs-mount]');
      var dataEl = root.querySelector('[data-ecs-data]');
      var statusEl = root.querySelector('[data-ecs-status]');

      if (mount && mount.parentNode) {
        mount.parentNode.insertBefore(root, mount);
        mount.parentNode.removeChild(mount);
      }

      root.hidden = false;

      if (!dataEl) {
        if (statusEl) {
          statusEl.textContent = 'Custom set data could not be loaded.';
          statusEl.classList.add('is-error');
        }
        return;
      }

      var data;
      try {
        data = JSON.parse(dataEl.textContent);
      } catch (error) {
        if (statusEl) {
          statusEl.textContent = 'Custom set data could not be loaded.';
          statusEl.classList.add('is-error');
        }
        console.error('[ESSNTL custom set] product data parse error', error);
        return;
      }

      if (!data.products || !data.products.length) {
        if (statusEl) {
          statusEl.textContent = 'No custom set products are available.';
          statusEl.classList.add('is-error');
        }
        return;
      }

      data.products.forEach(function (product, index) {
        prepareProductData(product, index);
      });

      root.setAttribute('data-ecs-init', 'true');

      var families = {
        top: ['hoodie', 'zip_hoodie'],
        bottom: ['shorts', 'sweats']
      };
      var familyLabels = {
        hoodie: 'Hoodie',
        zip_hoodie: 'Zip Hoodie',
        shorts: 'Shorts',
        sweats: 'Sweats'
      };
      var state = {
        top: { family: 'hoodie', productId: null, color: null, size: null },
        bottom: { family: 'shorts', productId: null, color: null, size: null },
        loading: false,
        success: false
      };

      var cta = root.querySelector('[data-ecs-add]');
      var ctaLabel = root.querySelector('[data-ecs-cta-label]');
      var pricing = root.querySelector('[data-ecs-pricing]');
      var originalPrice = root.querySelector('[data-ecs-original]');
      var totalPrice = root.querySelector('[data-ecs-total]');
      var savingPrice = root.querySelector('[data-ecs-saving]');
      var productPage = sectionScope.querySelector('[data-essntl-product-page]');
      var discountPercent = Math.max(0, Math.min(100, parseInt(data.discount_percent, 10) || 0));
      var activeBundleId = null;
      var cleanupCallbacks = [];

      function productsForFamily(family) {
        return data.products.filter(function (product) { return product.family === family; });
      }

      function sideHasProducts(side) {
        return families[side].some(function (family) {
          return productsForFamily(family).length > 0;
        });
      }

      function sideForFamily(family) {
        return families.top.indexOf(family) !== -1 ? 'top' : 'bottom';
      }

      function firstAvailableFamily(side, preferred) {
        var list = families[side];
        if (preferred && productsForFamily(preferred).length) return preferred;

        for (var i = 0; i < list.length; i += 1) {
          if (productsForFamily(list[i]).length) return list[i];
        }

        return list[0];
      }

      function getProduct(side) {
        var id = String(state[side].productId || '');
        if (!id) return null;
        return data.products.find(function (product) { return String(product.id) === id; }) || null;
      }

      function optionAt(variant, index) {
        return rawOptionAt(variant, index);
      }

      function optionValuesEqual(first, second) {
        return String(first == null ? '' : first).trim().toLowerCase()
          === String(second == null ? '' : second).trim().toLowerCase();
      }

      function variantColorIndex(product) {
        var index = parseInt(product && product.variant_color_index, 10);
        return isFinite(index) ? index : -1;
      }

      function variantMatchesColor(product, variant, color) {
        var colorIndex = variantColorIndex(product);
        if (!product || !variant || colorIndex < 0) return true;
        if (!color) return false;
        return optionValuesEqual(optionAt(variant, colorIndex), color);
      }

      function firstVariantForColor(product, color) {
        if (!product || !product.variants || !product.variants.length) return null;
        return product.variants.find(function (variant) {
          return variantMatchesColor(product, variant, color);
        }) || null;
      }

      function firstAvailableVariant(product, color) {
        if (!product || !product.variants || !product.variants.length) return null;
        return product.variants.find(function (variant) {
          return variant.available && variantMatchesColor(product, variant, color);
        }) || null;
      }

      function findVariant(product, size, color) {
        if (!product || !product.variants || !product.variants.length) return null;
        if (product.size_index < 0) return firstAvailableVariant(product, color);
        if (!size) return null;

        return product.variants.find(function (variant) {
          return variant.available
            && variantMatchesColor(product, variant, color)
            && optionValuesEqual(optionAt(variant, product.size_index), size);
        }) || null;
      }

      function colorOptions(product) {
        if (!product) return [];
        if (variantColorIndex(product) >= 0) return product._option_colors.slice();
        return [displayColor(product, null) || product.title];
      }

      function firstAvailableColor(product, preferred) {
        if (!product) return null;
        if (variantColorIndex(product) < 0) return colorOptions(product)[0] || product.title;
        if (preferred && firstAvailableVariant(product, preferred)) return preferred;

        var colors = colorOptions(product);
        for (var i = 0; i < colors.length; i += 1) {
          if (firstAvailableVariant(product, colors[i])) return colors[i];
        }
        return colors[0] || null;
      }

      function sizeIsAvailable(product, size, color) {
        return !!findVariant(product, size, color);
      }

      function normaliseProductSize(side, previousSize) {
        var product = getProduct(side);
        if (!product) {
          state[side].size = null;
          return;
        }

        if (product.size_index < 0 && firstAvailableVariant(product, state[side].color)) {
          state[side].size = 'Default Title';
          return;
        }

        state[side].size = previousSize && sizeIsAvailable(product, previousSize, state[side].color) ? previousSize : null;
      }

      function formatMoney(cents) {
        var amount = (parseInt(cents, 10) || 0) / 100;
        try {
          return new Intl.NumberFormat(data.locale || undefined, {
            style: 'currency',
            currency: data.currency
          }).format(amount);
        } catch (error) {
          return amount.toFixed(2) + ' ' + (data.currency || '');
        }
      }

      function setStatus(message, isError) {
        if (!statusEl) return;
        statusEl.textContent = message || '';
        statusEl.classList.toggle('is-error', !!isError);
      }

      function renderTabs(side) {
        var tabs = root.querySelector('[data-ecs-step="' + side + '"] .essntl-custom-set__tabs');

        root.querySelectorAll('[data-ecs-tab][data-side="' + side + '"]').forEach(function (tab) {
          var family = tab.getAttribute('data-family');
          var available = productsForFamily(family).length > 0;
          var active = available && state[side].family === family;

          tab.hidden = !available;
          tab.disabled = !available;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.setAttribute('aria-disabled', available ? 'false' : 'true');
        });

        if (tabs) tabs.hidden = !sideHasProducts(side);
      }

      function productDisplayVariant(product, side, color) {
        return findVariant(product, state[side].size, color)
          || firstAvailableVariant(product, color)
          || firstVariantForColor(product, color)
          || product.variants[0]
          || null;
      }

      function createProductButton(product, side, cardColor) {
        var button = document.createElement('button');
        var imageWrap = document.createElement('span');
        var type = document.createElement('span');
        var color = document.createElement('span');
        var displayVariant = productDisplayVariant(product, side, cardColor);
        var cardAvailable = !!firstAvailableVariant(product, cardColor);
        var selected = String(state[side].productId) === String(product.id)
          && (variantColorIndex(product) < 0 || optionValuesEqual(state[side].color, cardColor));
        var cardDisplayColor = displayColor(product, cardColor);

        button.type = 'button';
        button.className = 'essntl-custom-set__product';
        button.setAttribute('data-ecs-product-id', product.id);
        button.setAttribute('data-ecs-product-color', cardColor || '');
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        button.setAttribute('aria-disabled', cardAvailable ? 'false' : 'true');
        button.setAttribute('aria-label', familyLabels[product.family] + ' in ' + cardDisplayColor);
        button.disabled = !cardAvailable;
        button.classList.toggle('is-selected', selected);

        imageWrap.className = 'essntl-custom-set__product-image';
        var cardImage = displayVariant && displayVariant.image ? displayVariant.image : product.image;
        if (cardImage) {
          var image = document.createElement('img');
          image.src = cardImage;
          image.alt = product.title + (cardDisplayColor ? ' — ' + cardDisplayColor : '');
          image.loading = 'lazy';
          imageWrap.appendChild(image);
        }

        type.className = 'essntl-custom-set__product-type';
        type.textContent = familyLabels[product.family] || product.family;
        color.className = 'essntl-custom-set__product-color';
        color.textContent = cardDisplayColor;

        button.appendChild(imageWrap);
        button.appendChild(type);
        button.appendChild(color);

        if (data.show_card_prices && displayVariant) {
          var price = document.createElement('span');
          price.className = 'essntl-custom-set__product-price';
          price.textContent = displayVariant.price_formatted || formatMoney(displayVariant.price);
          button.appendChild(price);
        }

        return button;
      }

      function renderProducts(side) {
        var container = root.querySelector('[data-ecs-products="' + side + '"]');
        var empty = root.querySelector('[data-ecs-empty="' + side + '"]');
        var products = productsForFamily(state[side].family);

        if (!container) return;
        container.innerHTML = '';

        var cards = [];
        var stableIndex = 0;
        products.forEach(function (product) {
          colorOptions(product).forEach(function (color, colorIndex) {
            cards.push({
              product: product,
              color: color,
              priority: colorPriority(product, color),
              sourceIndex: product._source_index,
              colorIndex: colorIndex,
              stableIndex: stableIndex
            });
            stableIndex += 1;
          });
        });

        cards.sort(function (first, second) {
          return first.priority - second.priority
            || first.sourceIndex - second.sourceIndex
            || first.colorIndex - second.colorIndex
            || first.stableIndex - second.stableIndex;
        });

        cards.forEach(function (card) {
          container.appendChild(createProductButton(card.product, side, card.color));
        });

        if (empty) empty.hidden = true;
        container.hidden = cards.length === 0;
      }

      function sizeOptions(product, side) {
        if (!product || product.size_index < 0) return [];
        var seen = {};
        var options = [];

        product.variants.forEach(function (variant) {
          if (!variantMatchesColor(product, variant, state[side].color)) return;
          var value = optionAt(variant, product.size_index).trim();
          var key = value.toLowerCase();
          if (!value) return;

          if (!Object.prototype.hasOwnProperty.call(seen, key)) {
            seen[key] = options.length;
            options.push({ value: value, available: !!variant.available });
          } else if (variant.available) {
            options[seen[key]].available = true;
          }
        });

        return options;
      }

      function renderSizes(side) {
        var product = getProduct(side);
        var wrap = root.querySelector('[data-ecs-size-wrap="' + side + '"]');
        var container = root.querySelector('[data-ecs-sizes="' + side + '"]');
        var value = root.querySelector('[data-ecs-size-value="' + side + '"]');

        if (!wrap || !container) return;
        container.innerHTML = '';

        if (!product || product.size_index < 0) {
          wrap.hidden = true;
          if (value) value.textContent = product ? 'One size' : 'Select size';
          return;
        }

        wrap.hidden = false;
        if (value) value.textContent = state[side].size || 'Select size';

        sizeOptions(product, side).forEach(function (sizeOption) {
          var button = document.createElement('button');
          var selected = state[side].size === sizeOption.value;

          button.type = 'button';
          button.className = 'essntl-custom-set__size';
          button.textContent = sizeOption.value;
          button.disabled = !sizeOption.available;
          button.setAttribute('data-ecs-size', sizeOption.value);
          button.setAttribute('role', 'radio');
          button.setAttribute('aria-checked', selected ? 'true' : 'false');
          button.setAttribute('aria-disabled', sizeOption.available ? 'false' : 'true');
          button.setAttribute('aria-label', sizeOption.value + (sizeOption.available ? '' : ' — Sold Out'));
          button.classList.toggle('is-selected', selected);
          container.appendChild(button);
        });
      }

      function updatePreview(side) {
        var product = getProduct(side);
        var imageWrap = root.querySelector('[data-ecs-preview-image="' + side + '"]');
        var name = root.querySelector('[data-ecs-preview-name="' + side + '"]');
        var meta = root.querySelector('[data-ecs-preview-meta="' + side + '"]');

        if (!name || !meta) return;
        if (imageWrap) imageWrap.innerHTML = '';

        if (!product) {
          name.textContent = side === 'top' ? 'Choose your top' : 'Choose your bottom';
          meta.textContent = 'Size —';
          return;
        }

        var previewVariant = findVariant(product, state[side].size, state[side].color)
          || firstAvailableVariant(product, state[side].color)
          || firstVariantForColor(product, state[side].color);
        var previewImage = previewVariant && previewVariant.image ? previewVariant.image : product.image;

        if (imageWrap && previewImage) {
          var image = document.createElement('img');
          image.src = previewImage;
          image.alt = product.title;
          image.loading = 'lazy';
          imageWrap.appendChild(image);
        }

        name.textContent = familyLabels[product.family] || product.title;
        meta.textContent = displayColor(product, state[side].color)
          + ' · Size '
          + (state[side].size && state[side].size !== 'Default Title' ? state[side].size : '—');
      }

      function selectedVariants() {
        return {
          top: findVariant(getProduct('top'), state.top.size, state.top.color),
          bottom: findVariant(getProduct('bottom'), state.bottom.size, state.bottom.color)
        };
      }

      function calculatePricing() {
        var variants = selectedVariants();
        if (!variants.top || !variants.bottom) return null;

        var original = (parseInt(variants.top.price, 10) || 0) + (parseInt(variants.bottom.price, 10) || 0);
        var saved = Math.round(original * discountPercent / 100);

        return {
          original: original,
          saved: saved,
          total: original - saved,
          variants: variants
        };
      }

      function renderPricing() {
        var totals = calculatePricing();
        if (!pricing) return;

        pricing.hidden = !totals;
        if (!totals) return;

        if (originalPrice) originalPrice.textContent = formatMoney(totals.original);
        if (totalPrice) totalPrice.textContent = formatMoney(totals.total);
        if (savingPrice) savingPrice.textContent = 'YOU SAVE ' + formatMoney(totals.saved);
      }

      function validationState() {
        var topProducts = families.top.reduce(function (count, family) { return count + productsForFamily(family).length; }, 0);
        var bottomProducts = families.bottom.reduce(function (count, family) { return count + productsForFamily(family).length; }, 0);
        var topProduct = getProduct('top');
        var bottomProduct = getProduct('bottom');
        var variants = selectedVariants();

        if (!topProducts || !bottomProducts) return { valid: false, text: 'COMPLETE YOUR SET', groupMissing: true };
        if (!topProduct) return { valid: false, text: 'CHOOSE YOUR TOP' };
        if (!bottomProduct) return { valid: false, text: 'CHOOSE YOUR BOTTOM' };
        if (!variants.top) return { valid: false, text: 'SELECT TOP SIZE' };
        if (!variants.bottom) return { valid: false, text: 'SELECT BOTTOM SIZE' };
        if (!variants.top.available || !variants.bottom.available) return { valid: false, text: 'COMPLETE YOUR SET' };
        return { valid: true, text: data.cta_text || 'ADD CUSTOM SET TO BAG' };
      }

      function renderCTA() {
        if (!cta || !ctaLabel) return;
        var validation = validationState();

        if (!state.loading && !state.success) ctaLabel.textContent = validation.text;
        cta.disabled = !validation.valid || state.loading || state.success;
        cta.classList.toggle('is-loading', state.loading);
        cta.classList.toggle('is-success', state.success);
        root.setAttribute('aria-busy', state.loading ? 'true' : 'false');

        if (validation.groupMissing && !state.loading && !state.success) {
          setStatus('A top or bottom product collection is currently unavailable.', true);
        }
      }

      function renderSide(side) {
        var step = root.querySelector('[data-ecs-step="' + side + '"]');
        var hasProducts = sideHasProducts(side);

        if (step) step.hidden = !hasProducts;
        renderTabs(side);
        renderProducts(side);
        renderSizes(side);
        updatePreview(side);
      }

      function renderAll() {
        var summary = root.querySelector('.essntl-custom-set__summary');

        renderSide('top');
        renderSide('bottom');
        if (summary) summary.hidden = !(sideHasProducts('top') && sideHasProducts('bottom'));
        renderPricing();
        renderCTA();
      }

      function selectFamily(side, family) {
        if (families[side].indexOf(family) === -1 || !productsForFamily(family).length) return;
        state[side].family = family;

        var selected = getProduct(side);
        if (!selected || selected.family !== family) {
          state[side].productId = null;
          state[side].color = null;
          state[side].size = null;
        }

        setStatus('', false);
        renderAll();
      }

      function selectProduct(side, productId, selectedColor) {
        var product = data.products.find(function (candidate) {
          return String(candidate.id) === String(productId) && candidate.family === state[side].family;
        });
        if (!product) return;

        var nextColor = variantColorIndex(product) >= 0
          ? firstAvailableColor(product, selectedColor)
          : (colorOptions(product)[0] || product.title);
        if (!nextColor || !firstAvailableVariant(product, nextColor)) return;

        var previousSize = state[side].size;
        state[side].productId = product.id;
        state[side].color = nextColor;
        normaliseProductSize(side, previousSize);
        setStatus('', false);
        renderAll();
      }

      function selectSize(side, size) {
        var product = getProduct(side);
        if (!product || !sizeIsAvailable(product, size, state[side].color)) return;
        state[side].size = size;
        setStatus('', false);
        renderAll();
      }

      function route(path) {
        var rootUrl = data.root_url || '/';
        if (rootUrl.charAt(rootUrl.length - 1) !== '/') rootUrl += '/';
        return rootUrl + String(path || '').replace(/^\//, '');
      }

      function fetchCart() {
        return fetch(route('cart.js'), {
          method: 'GET',
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json' }
        }).then(function (response) {
          if (!response.ok) throw new Error('Could not verify the custom set in your bag.');
          return response.json();
        });
      }

      function bundleLines(cart, bundleId) {
        return (cart && cart.items ? cart.items : []).filter(function (item) {
          return item.properties && String(item.properties._essntl_custom_set_id || '') === String(bundleId);
        });
      }

      function rollbackBundle(cart, bundleId) {
        var lines = bundleLines(cart, bundleId);
        if (!lines.length) return Promise.resolve(cart);
        var updates = {};
        lines.forEach(function (line) { if (line.key) updates[line.key] = 0; });

        return fetch(route('cart/update.js'), {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function (response) {
          if (!response.ok) throw new Error('The incomplete custom set could not be removed automatically.');
          return response.json();
        });
      }

      function applyDiscountCode() {
        var code = String(data.discount_code || '').trim();
        if (!code) return Promise.resolve();

        var redirect = route('cart.js');
        return fetch(route('discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirect)), {
          method: 'GET',
          credentials: 'same-origin',
          redirect: 'follow',
          headers: { 'Accept': 'application/json, text/html' }
        }).then(function (response) {
          if (!response.ok) throw new Error('The custom set discount code is unavailable.');
        });
      }

      function verifyDiscount(cart, bundleId, expectedSavings) {
        var lines = bundleLines(cart, bundleId);
        var actualSavings = lines.reduce(function (sum, line) {
          var original = parseInt(line.original_line_price, 10);
          var finalPrice = parseInt(line.final_line_price, 10);
          if (!isFinite(original)) original = finalPrice;
          if (!isFinite(finalPrice)) finalPrice = original;
          return sum + Math.max(0, original - finalPrice);
        }, 0);

        if (lines.length === 2 && actualSavings + 1 >= expectedSavings) return Promise.resolve(cart);

        return rollbackBundle(cart, bundleId).then(function () {
          var error = new Error(lines.length !== 2
            ? 'The complete custom set could not be added. Please try again.'
            : 'The custom set discount is unavailable, so the set was not added.');
          error.rolledBack = true;
          throw error;
        });
      }

      function announceCart(cart) {
        window.ESSNTL_LAST_CART = cart;
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('essntl:cart-drawer:open', {
          bubbles: true,
          detail: { cart: cart, resource: cart }
        }));
      }

      function resetSuccess() {
        state.success = false;
        renderCTA();
        setStatus('', false);
      }

      function addCustomSet() {
        if (state.loading || state.success) return;

        var validation = validationState();
        var totals = calculatePricing();
        var topProduct = getProduct('top');
        var bottomProduct = getProduct('bottom');

        if (!validation.valid || !totals || !topProduct || !bottomProduct) {
          renderCTA();
          return;
        }

        state.loading = true;
        renderCTA();
        setStatus('', false);

        activeBundleId = 'essntl-custom-set-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8);
        var combination = topProduct.title
          + ' (' + (state.top.color || 'Default') + ', ' + (state.top.size || 'One size') + ') + '
          + bottomProduct.title
          + ' (' + (state.bottom.color || 'Default') + ', ' + (state.bottom.size || 'One size') + ')';
        var sharedProperties = {
          '_essntl_bundle_name': 'Build Your Own Set',
          '_essntl_custom_set_id': activeBundleId,
          '_essntl_custom_set_discount': discountPercent + '%',
          '_essntl_custom_set_combination': combination
        };
        var topProperties = Object.assign({}, sharedProperties, { '_essntl_custom_set_role': 'top' });
        var bottomProperties = Object.assign({}, sharedProperties, { '_essntl_custom_set_role': 'bottom' });
        var payload = {
          items: [
            { id: totals.variants.top.id, quantity: 1, properties: topProperties },
            { id: totals.variants.bottom.id, quantity: 1, properties: bottomProperties }
          ]
        };

        fetch(route('cart/add.js'), {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        })
          .then(function (response) {
            if (!response.ok) {
              return response.json().catch(function () { return {}; }).then(function (error) {
                throw new Error(error.description || error.message || 'The selected set could not be added.');
              });
            }
            return response.json();
          })
          .then(function () { return applyDiscountCode(); })
          .then(fetchCart)
          .then(function (cart) { return verifyDiscount(cart, activeBundleId, totals.saved); })
          .then(function (cart) {
            state.loading = false;
            state.success = true;
            if (ctaLabel) ctaLabel.textContent = 'SET ADDED TO BAG';
            renderCTA();
            setStatus('Your custom set was added with the bundle discount.', false);
            announceCart(cart);
            window.setTimeout(resetSuccess, 1800);
          })
          .catch(function (error) {
            var finishFailure = function (message) {
              state.loading = false;
              state.success = false;
              renderCTA();
              setStatus(message || 'The selected set could not be added. Please try again.', true);
            };

            if (error && error.rolledBack) {
              finishFailure(error.message);
              document.dispatchEvent(new CustomEvent('cart:refresh'));
              return;
            }

            fetchCart()
              .then(function (cart) { return rollbackBundle(cart, activeBundleId); })
              .then(function () {
                finishFailure(error && error.message);
                document.dispatchEvent(new CustomEvent('cart:refresh'));
              })
              .catch(function () {
                finishFailure('The set could not be completed. Please review the custom-set items in your bag.');
                document.dispatchEvent(new CustomEvent('essntl:cart-drawer:open'));
              });
          });
      }

      function handleRootClick(event) {
        var tab = event.target.closest('[data-ecs-tab]');
        if (tab && root.contains(tab)) {
          selectFamily(tab.getAttribute('data-side'), tab.getAttribute('data-family'));
          return;
        }

        var productButton = event.target.closest('[data-ecs-product-id]');
        if (productButton && root.contains(productButton)) {
          var product = data.products.find(function (candidate) { return String(candidate.id) === String(productButton.getAttribute('data-ecs-product-id')); });
          if (product) selectProduct(sideForFamily(product.family), product.id, productButton.getAttribute('data-ecs-product-color'));
          return;
        }

        var sizeButton = event.target.closest('[data-ecs-size]');
        if (sizeButton && root.contains(sizeButton)) {
          var step = sizeButton.closest('[data-ecs-step]');
          if (step) selectSize(step.getAttribute('data-ecs-step'), sizeButton.getAttribute('data-ecs-size'));
          return;
        }

        if (event.target.closest('[data-ecs-add]')) addCustomSet();
      }

      function handleMainSizeClick(event) {
        var button = event.target.closest('.essntl-size-btn');
        if (!button || button.disabled) return;

        var side = sideForFamily(data.current_family);
        if (String(state[side].productId) !== String(data.current_product_id)) return;

        var size = button.getAttribute('data-size') || '';
        if (sizeIsAvailable(getProduct(side), size, state[side].color)) {
          state[side].size = size;
          setStatus('', false);
          renderAll();
        }
      }

      state.top.family = firstAvailableFamily('top', families.top.indexOf(data.current_family) !== -1 ? data.current_family : null);
      state.bottom.family = firstAvailableFamily('bottom', families.bottom.indexOf(data.current_family) !== -1 ? data.current_family : null);

      if (families.top.indexOf(data.current_family) !== -1) {
        state.top.productId = data.current_product_id;
        state.top.color = firstAvailableColor(getProduct('top'), data.initial_color || null);
        normaliseProductSize('top', data.initial_size || null);
      } else if (families.bottom.indexOf(data.current_family) !== -1) {
        state.bottom.productId = data.current_product_id;
        state.bottom.color = firstAvailableColor(getProduct('bottom'), data.initial_color || null);
        normaliseProductSize('bottom', data.initial_size || null);
      }

      root.addEventListener('click', handleRootClick);
      cleanupCallbacks.push(function () { root.removeEventListener('click', handleRootClick); });

      if (productPage) {
        productPage.addEventListener('click', handleMainSizeClick);
        cleanupCallbacks.push(function () { productPage.removeEventListener('click', handleMainSizeClick); });
      }

      root.__essntlCustomSetDestroy = function () {
        cleanupCallbacks.forEach(function (cleanup) { cleanup(); });
        cleanupCallbacks = [];
        root.removeAttribute('data-ecs-init');
        if (registry.instances[sectionId] === root) delete registry.instances[sectionId];
      };

      registry.instances[sectionId] = root;
      renderAll();
    }

    registry.init = function (scope) {
      var target = scope || document;
      if (target.matches && target.matches('[data-essntl-custom-set]')) initRoot(target);
      if (target.querySelectorAll) {
        target.querySelectorAll('[data-essntl-custom-set]').forEach(initRoot);
      }
    };

    if (!registry.lifecycleBound) {
      registry.lifecycleBound = true;
      document.addEventListener('shopify:section:load', function (event) { registry.init(event.target); });
      document.addEventListener('shopify:section:unload', function (event) {
        if (!event.target || !event.target.querySelectorAll) return;
        event.target.querySelectorAll('[data-essntl-custom-set]').forEach(function (root) {
          if (root.__essntlCustomSetDestroy) root.__essntlCustomSetDestroy();
        });
      });
    }

    window.ESSNTLCustomSet = registry;
    registry.init(document);
  })();